<!-- 活动规则 -->
<template>
  <div>
    <vanPopup v-model="show" class="padding-20">
      <div class="main">
        <div class="title">
          <img class="title-img" :src="titleImg" alt="">
          <img @click="close" class="close-icon" :src="closeIcon" alt="close">
        </div>
        <div class="content">
          <div class="content-item">
            <p>一、活动日期</p>
            <p>2025年03月01日至2025年12月31日（北京时间）</p>
          </div>
          <div class="content-item">
            <p>二、活动对象</p>
            <p>您邀请的好友须是PhotonPay光子易新企业用户，即未在PhotonPay光子易注册的企业用户</p>
            <p class="tips">
              *被光子易认定的集团客户除外。
            </p>
          </div>
          <div class="content-item">
            <p>三、活动规则</p>
            <p>在活动期间，您的好友成功通过您专属链接，完成注册成为PhotonPay光子易新企业用户，并在注册90天内从支持的电商平台累计入账大于或等于500美元。就每一名达到成功推荐条件的好友，您可获得最高人民币500元奖励。</p>
            <div class="bg-img">
              <div class="rules-title">收款</div>
              <p class="rules-desc">注册90天内，电商平台（例如亚马逊、TikTok Shop、SHEIN等）累计收款不少于 500美元</p>
            </div>
          </div>
          <div class="content-item">
            <p>四、奖励计算</p>
            <p>奖励费=当月达到成功推荐条件的被推荐数*所属阶梯的“激活奖励费”</p>
          </div>
          <div class="content-item">
            <p>五、结算周期</p>
            <p>达成交易条件后，推荐人将于次月的最后一个工作日前获得推介费用</p>
            <p class="tips">* “工作日”指中华人民共和国法定工作日（即非双休日或法定节假日的日子）</p>
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import closeIcon from '@/assets/images/home/closeIcon.png'
import rulesItem from '@/assets/images/home/rules.png'
import titleImg from '@/assets/images/home/title-ac.png'
export default {
  name: 'activity',
  data() {
    return {
      closeIcon,
      rulesItem,
      titleImg,
      show: false
    }
  },
  methods: {
    openShow() {
      this.show = true
    },
    // 关闭窗口
    close() {
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.main {
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-sizing: border-box;
  .title {
    position: sticky;
    top: 0;
    left: 0;
    background: url(~@/assets/images/home/title-bg.png) no-repeat top;
    background-size: 100% auto;
    background-color: #fff;
    font-size: 24px;
    font-weight: 800;
    color: #666666;
    line-height: 60px;
    height: 60px;
    text-align: center;
    .title-img{
      width: 80px;
      height: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    .close-icon{
      width: 22px;
      height: 22px;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .content{
    padding: 0 27px;
    font-size: 12px;
    color: #666;
    line-height: 18px;
    margin-top: 14px;
    .tips{
      font-size: 10px;
      color: #9F9F9F;
    }
    .bg-img{
      box-sizing: border-box;
      margin:15px 0;
      width: 100%;
      background: url(~@/assets/images/home/rules-bg.png) no-repeat center;
      background-size: 100% auto;
      height: 70px;
      color: #302B3E;
      padding: 10px 17.5px 10px;
      .rules-title{
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      .rules-desc{
        font-size: 10px;
        line-height: 14px;
      }
    }
    img{
      width: 100%;
      height: auto;
    }
  }
  .content-item{
    margin-bottom: 20px;
  }
}
/deep/.van-popup--center{
  height: calc(100vh - 200px);
  bottom: 0;
  left: 0;
  padding: 0;
  transform: none;
  top: auto;
  border-radius: 12px 12px 0px 0px;
}
</style>
